import { render, staticRenderFns } from "./ClientResponsibleGaming.vue?vue&type=template&id=479924ab&"
import script from "./ClientResponsibleGaming.vue?vue&type=script&lang=js&"
export * from "./ClientResponsibleGaming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports